<template>
  <Homepage />
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Homepage from '@/components/Homepage.vue'

export default {
  name: 'Home',
  components: {
    // HelloWorld
    Homepage
  }
}
</script>
